const testData = [
	// {
	// 	path: "/testData",
	// 	name: "testData",
	// 	component: () => import("../views/testData/index.vue"),
	// },
];

export default testData;
